import React from 'react';
import './HeroNew.css'
import one from '../../assets/1.webp';
import two from '../../assets/2.webp';
import three from '../../assets/3.webp';
import four from '../../assets/4.webp';
import five from '../../assets/5.webp';
import six from '../../assets/6.webp';
import seven from '../../assets/7.webp';
import eight from '../../assets/8.webp';
import nine from '../../assets/9.webp';
import ten from '../../assets/10.webp';
import { useGlobalState } from '../../state';
import { WalletDialogButton } from '@solana/wallet-adapter-material-ui'

const HeroNew = () => {
  const data = [
    {
      image: one
    },
    {
      image: two
    },
    {
      image: three
    },
    {
      image: four
    },
    {
      image: five
    },
    {
      image: six
    },
    {
      image: seven
    },
    {
      image: eight
    },
    {
      image: nine
    },
    {
      image: ten
    },
  ] 
  const [darkMode] = useGlobalState('darkMode')

  return (
    <div style={{backgroundColor: darkMode ? '#101111' : '#fff'}} className="hero-new-container">
      <div style={{color: darkMode ? '#fff' : '#000'}} className="hero-new-main">
        <h1>The project that inspired the modern CryptoArt movement</h1>
        <p style={{color: darkMode ? '#fff' : '#101111'}}>10,000 unique collectible characters with proof of ownership stored on the Ethereum blockchain.</p>
        <WalletDialogButton>
          Mint now
        </WalletDialogButton>
      </div>
      <div className="carousel-new">
        <div className="carousel-wrapper">
          {data.map((item, key) => (
            
              <img key={key} src={item.image} alt="nft" />
            
          ))}
          <img src={one} alt="nft" />
          <img src={two} alt="nft" />
          <img src={three} alt="nft" />
          <img src={four} alt="nft" />
          <img src={five} alt="nft" />
        </div>
      </div>
    </div>
  )
}

export default HeroNew